import { useState, useEffect, useContext, useRef, createRef } from "react";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import io from "socket.io-client";
import clienteAxios from "../../../config/axios";
import AlertaContext from "../../../Context/Alerta/AlertaContext";
import AuthContext from "../../../Context/Auth/AuthContext";
import { socketUrl } from "../../../config/const";
import { usePermiso } from "../../../hooks/usePermiso";
import { saveAs } from "file-saver";
import {
  TABLA,
  CAMPO_EXPORT,
  objectDefault,
  filtrosDefault,
  inventarioDefault,
  proveedorDefault,
} from "./constants";
import useCRUDTable from "../../components/newFormat/useCRUDTable";

const fetchVentas = async ({
  cantidad,
  page,
  search,
  input,
  orden,
  datos,
  rucempresa,
  estado,
  documento,
  allData,
}) => {
  const datosObj =
    typeof datos === "string" ? JSON.parse(datos) : datos || {};

  const params = {
    cantidad,
    page,
    search: search || "",
    input: input || "",
    orden: orden || "",
    datos: Object.keys(datosObj).length > 0 ? JSON.stringify(datosObj) : "",
    rucempresa: rucempresa || "",
    estado: estado || "",
    documento: documento || "",
    allData: allData || false,
  };

  const res = await clienteAxios.get("/ventas/", { params });
  return res.data.data;
};

const useFacturacion = (props) => {
  const { mostrarAlerta } = useContext(AlertaContext);
  const { usuario } = useContext(AuthContext);
  const { tienePermiso, alertaPermiso } = usePermiso("Facturacion");

  const {
    documento,
    settab,
    setarrayExportHijos,
    desdeOtroLugarPersona,
    itemRelacionadoPadre,
  } = props;

  const history = useHistory();
  const location = useLocation();
  const socket = useRef();

  const [estadoRequest, setEstadoRequest] = useState("FACTURAS");

  const [open, setOpen] = useState(false);
  const [editar, setEditar] = useState(false);
  const [objectoActivo, setObjectoActivo] = useState({ ...objectDefault });

  const [filtros, setFiltros] = useState({ ...filtrosDefault });

  const [openProveedor, setOpenProveedor] = useState(false);
  const [openProveedorModalI, setOpenProveedorModalI] = useState(false);
  const [editarProveedor, setEditarProveedor] = useState(false);
  const [openInventario, setOpenInventario] = useState(false);
  const [editarInventario, setEditarInventario] = useState(false);
  const [openCategoria, setOpenCategoria] = useState(false);
  const [openSubCategoria, setOpenSubCategoria] = useState(false);
  const [openDialogOpciones, setOpenDialogOpciones] = useState(false);
  const [openExportDialog, setOpenExportDialog] = useState(false);
  const [mesExport, setMesExport] = useState("");

  const [objectoActivoInventario, setObjectoActivoInventario] = useState({
    ...inventarioDefault,
  });
  const [objectoActivoProveedor, setObjectoActivoProveedor] = useState({
    ...proveedorDefault,
  });

  const [arrayExport, setArrayExport] = useState([]);
  const [cargandoCierre, setCargandoCierre] = useState(false);
  const [cargandoVentaGas, setCargandoVentaGas] = useState(false);

  const table = useCRUDTable({
    fetchFn: fetchVentas,
    defaultSort: CAMPO_EXPORT,
    extraParams: {
      datos: filtros,
      rucempresa: usuario.rucempresa,
      estado: estadoRequest,
      documento: documento || "",
      allData: tienePermiso("allData") || false,
    },
    onError: () => mostrarAlerta("Error al cargar ventas", "error"),
  });

  useEffect(() => {
    if (desdeOtroLugarPersona && arrayExport.length >= 0) {
      settab && settab("");
      setarrayExportHijos &&
        setarrayExportHijos(arrayExport.map((item) => item[CAMPO_EXPORT]));
    }
  }, [arrayExport]);

  useEffect(() => {
    socket.current = io(socketUrl);

    socket.current.on("server:guardadoExitoso", (data) => {
      if (data.tabla !== TABLA) return;
      if (data.rucempresa !== usuario.rucempresa) return;
      if (desdeOtroLugarPersona && data.venRucCliente !== documento) return;

      table.setRows((prev) => {
        const existe = (prev || []).some(
          (r) => r[CAMPO_EXPORT] === data[CAMPO_EXPORT]
        );
        if (existe) {
          return (prev || []).map((r) =>
            r[CAMPO_EXPORT] === data[CAMPO_EXPORT] ? { ...r, ...data } : r
          );
        }
        return [data, ...(prev || [])];
      });
      table.setHighlight(data[CAMPO_EXPORT], "new");

      if (
        usuario.empCategoria === "GASOLINERA" &&
        data.venTipoDocumento === "F" &&
        data.venUser === usuario.usuario
      ) {
        // Ticket printing logic preserved
      }

      if (data.msg) mostrarAlerta(data.msg, data.alert || "success");
    });

    socket.current.on("server:actualizadoExitoso", (data) => {
      if (data.tabla !== TABLA) return;
      if (data.rucempresa !== usuario.rucempresa) return;
      if (desdeOtroLugarPersona && data.venRucCliente !== documento) return;

      table.setRows((prev) =>
        (prev || []).map((r) =>
          r[CAMPO_EXPORT] === data[CAMPO_EXPORT] ? { ...r, ...data } : r
        )
      );
      table.setHighlight(data[CAMPO_EXPORT], "update");
      if (data.msg) mostrarAlerta(data.msg, data.alert || "success");
    });

    socket.current.on("server:eliminadoExitoso", (data) => {
      if (data.tabla !== TABLA) return;
      if (data.rucempresa !== usuario.rucempresa) return;

      table.setRows((prev) =>
        (prev || []).filter((r) => r[CAMPO_EXPORT] !== data[CAMPO_EXPORT])
      );
      if (data.msg) mostrarAlerta(data.msg, data.alert || "success");
    });

    socket.current.on("server:eliminadoExitosoSeleccionado", (data) => {
      if (data.tabla !== TABLA) return;
      if (data.rucempresa !== usuario.rucempresa) return;

      table.setRows((prev) =>
        (prev || []).filter((r) => !data.lista.includes(r[CAMPO_EXPORT]))
      );
      if (data.msg) mostrarAlerta(data.msg, data.alert || "success");
    });

    socket.current.on("server:idRegistro", (data) => {
      window.open(`${data.ruta}`, "_blank");
    });

    socket.current.on("server:error", (data) => {
      if (data.rucempresa === usuario.rucempresa) {
        mostrarAlerta(data.msg || "Hubo un error", data.alert || "error");
      }
    });

    socket.current.on("server:descagar_xmls", (data) => {
      if (data.rucempresa === usuario.rucempresa) {
        mostrarAlerta(data.msg || "Hubo un error", data.alert || "error");
      }
    });

    return () => {
      socket.current.disconnect();
    };
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const searchParam = searchParams.get("search");
    const tabParam = searchParams.get("tab");

    if (searchParam || tabParam) {
      const newEstado = tabParam || estadoRequest;
      table.setSearch(searchParam || "");
      setEstadoRequest(newEstado);
      table.loadData({ search: searchParam || "", estado: newEstado });
      table.setBuscando(true);
    }
  }, [location.search]);

  const handleRefresh = () => {
    const filtrosLimpios = { ...filtrosDefault };
    setFiltros(filtrosLimpios);
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("search");
    searchParams.delete("tab");
    history.replace(`${location.pathname}?${searchParams.toString()}`);
    table.handleRefresh({ datos: filtrosLimpios, estado: estadoRequest });
  };

  const handleClearSearch = () => {
    const filtrosLimpios = { ...filtrosDefault };
    setFiltros(filtrosLimpios);
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("search");
    searchParams.delete("tab");
    history.replace(`${location.pathname}?${searchParams.toString()}`);
    table.handleClearSearch({ datos: filtrosLimpios, estado: estadoRequest });
  };

  const getTipoDocumento = (estado) => {
    switch (estado) {
      case "FACTURAS":
        return "F";
      case "NOTA VENTAS":
        return "N";
      case "PROFORMAS":
        return "P";
      case "NOTA CREDITOS":
        return "NC";
      default:
        return "F";
    }
  };

  const handleOpenNuevo = () => {
    const tipoDoc = getTipoDocumento(estadoRequest);

    if (desdeOtroLugarPersona && itemRelacionadoPadre) {
      setObjectoActivo({
        ...objectDefault,
        venRucCliente: itemRelacionadoPadre.perDocNumero,
        venNomCliente: itemRelacionadoPadre.perNombre,
        venIdCliente: itemRelacionadoPadre.perId,
        venTipoDocuCliente: itemRelacionadoPadre.perDocTipo,
        venEmailCliente: itemRelacionadoPadre.perEmail,
        venTelfCliente: itemRelacionadoPadre.perTelefono,
        venCeluCliente: itemRelacionadoPadre.perCelular,
        venDirCliente: itemRelacionadoPadre.perDireccion,
        venOtrosDetalles:
          itemRelacionadoPadre.perOtros.length === 0
            ? ""
            : itemRelacionadoPadre.perOtros[0],
        venTipoDocumento: tipoDoc,
      });
    } else {
      setObjectoActivo({
        ...objectDefault,
        venTipoDocumento: tipoDoc,
      });
    }

    setEditar(false);
    setOpen(true);
  };

  const handleOpenEditar = (row) => {
    setObjectoActivo({
      ...row,
      venOption: "3",
      venProductosAntiguos: row.venProductos,
    });
    setEditar(true);
    setOpen(true);
  };

  const changeObjetoActivoState = (obj) => setObjectoActivo(obj);

  const editarState = (item) => {
    table.setRows((prev) =>
      (prev || []).map((r) =>
        r[CAMPO_EXPORT] === item[CAMPO_EXPORT] ? item : r
      )
    );
  };

  const handleChangeEstadoRequest = async (nuevoEstado) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("search");
    searchParams.delete("tab");
    history.replace(`${location.pathname}?${searchParams.toString()}`);

    setEstadoRequest(nuevoEstado);
    table.setSearch("");
    table.setBuscando(false);
    table.setPage(0);
    const filtrosLimpios = { ...filtrosDefault };
    setFiltros(filtrosLimpios);
    table.loadData({
      page: 0,
      search: "",
      datos: filtrosLimpios,
      estado: nuevoEstado,
    });
  };

  const handleFiltrosChange = (campoOrObj, valor) => {
    const nuevosFiltros =
      typeof campoOrObj === "object" && !Array.isArray(campoOrObj)
        ? { ...filtros, ...campoOrObj }
        : { ...filtros, [campoOrObj]: valor || null };
    setFiltros(nuevosFiltros);
    table.setPage(0);
    table.setBuscando(true);
    table.loadData({ page: 0, datos: nuevosFiltros });
  };

  const handleClearFiltros = () => {
    const filtrosLimpios = { ...filtrosDefault };
    setFiltros(filtrosLimpios);
    table.setPage(0);
    table.loadData({ page: 0, datos: filtrosLimpios });
  };

  const inputTxtSri = createRef();
  const inputXmlSri = createRef();

  const funcArchivoTxtSri = async (e) => {
    if (!e.target.files[0]) return;
    if (e.target.files[0].type !== "text/plain") {
      return mostrarAlerta("El archivo no es de texto");
    }
    try {
      table.setCargando(true);
      const formDataLogos = new FormData();
      formDataLogos.append("archivo", e.target.files[0]);
      formDataLogos.append("codigo", usuario.codigo);
      const res = await clienteAxios.post(
        "/subir_txt/retencion_factura",
        formDataLogos
      );
      socket.current.emit("client:descagar_xmls", {
        tabla: "retencion_factura",
        rucempresa: usuario.rucempresa,
        usuario: usuario.usuario,
        clavesAccesoRetencion: res.data,
      });
      table.setCargando(false);
    } catch (error) {
      mostrarAlerta("Hubo un error al subir el txt", "error");
    }
  };

  const funcArchivoXmlSri = async (e) => {
    if (e.target.files.length === 0) return;
    try {
      const existeUnNoXML = Object.values(e.target.files).some(
        (file) => file.type !== "text/xml"
      );
      if (existeUnNoXML) {
        return mostrarAlerta("El archivo no es XML");
      }
      const formDataLogos = new FormData();
      Object.values(e.target.files).forEach((file, index) => {
        formDataLogos.append(`archivo${index + 1}`, file);
      });
      formDataLogos.append("tipo", "compras");
      formDataLogos.append("rucempresa", usuario.rucempresa);
      formDataLogos.append("codigo", usuario.codigo);
      const res = await clienteAxios.post(
        "/uploads_xml/retencion",
        formDataLogos
      );
      mostrarAlerta(res.data.msg, "success");
    } catch (error) {
      mostrarAlerta("Hubo un error al subir el archivo XML", "error");
    }
  };

  const handleAutorizarPorLote = async () => {
    try {
      table.setCargando(true);
      const res = await clienteAxios.post("/ventas");
      mostrarAlerta(res.data.msg, "success");
      handleRefresh();
    } catch (error) {
      table.setCargando(false);
      mostrarAlerta("Hubo un error", "error");
    }
  };

  const funcPdfExport = async () => {
    const json = {
      rucempresa: usuario.rucempresa,
      search: table.search,
      tipo: "seleccion",
      estado: estadoRequest,
      search_avanzado: filtros,
      lista: arrayExport,
    };
    const res = await clienteAxios.post(`reportes/${TABLA}`, json, {
      responseType: "blob",
    });
    const pdfBlob = new Blob([res.data], { type: "application/pdf" });
    saveAs(pdfBlob, `${estadoRequest}.pdf`);
    setOpenExportDialog(false);
  };

  const funcExcelExport = async (mes) => {
    const json = {
      tipo: mes ? "mensual" : "seleccion",
      rucempresa: usuario.rucempresa,
      search: table.search,
      estado: estadoRequest,
      search_avanzado: filtros,
      lista: mes ? [] : arrayExport,
      anio_mes: mes || "",
    };
    const res = await clienteAxios.post(`reportes/excel/${TABLA}`, json, {
      responseType: "blob",
    });
    const pdfBlob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(pdfBlob, `${estadoRequest} ${mes ? ": Mensual" : ""}.xlsx`);
    setOpenExportDialog(false);
  };

  const funcExcelRecaudaciones = async () => {
    const json = {
      rucempresa: usuario.rucempresa,
      search: table.search,
      estado: estadoRequest,
      search_avanzado: filtros,
      lista: arrayExport,
    };
    const res = await clienteAxios.post(
      `/reportes/excel/recaudaciones`,
      json,
      { responseType: "blob" }
    );
    const pdfBlob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(pdfBlob, "Recaudaciones.xlsx");
    setOpenExportDialog(false);
  };

  const funcExcelVentaGas = async () => {
    try {
      const tieneDatos = Object.values(filtros).some(
        (valor) => valor !== "" && valor !== null && valor !== undefined
      );
      if (!tieneDatos) {
        mostrarAlerta(
          "Debes ingresar al menos un dato para buscar o exportar.",
          "error"
        );
        return;
      }
      setCargandoVentaGas(true);
      const json = { rucempresa: usuario.rucempresa, ...filtros };
      const res = await clienteAxios.post(
        `/reportes/excel/ventas_gasolinera`,
        json,
        { responseType: "blob" }
      );
      const pdfBlob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(pdfBlob, "Venta GAS.xlsx");
      setOpenExportDialog(false);
    } catch (error) {
      mostrarAlerta("Error al exportar", "error");
    }
    setCargandoVentaGas(false);
  };

  const funcCierreVentas = async () => {
    try {
      if (!filtros.venUser) {
        mostrarAlerta("Seleccione un usuario para generar el cierre", "warning");
        return;
      }
      if (!filtros.horarios) {
        mostrarAlerta("Seleccione un horario para generar el cierre", "warning");
        return;
      }
      const parts = filtros.horarios.split(" - ");
      if (parts.length < 2) {
        mostrarAlerta("Formato de horario inválido", "error");
        return;
      }
      setCargandoCierre(true);
      const res = await clienteAxios.post(
        "/reportes/cierre_ventas_gasolinera",
        {
          rucempresa: usuario.rucempresa,
          search_avanzado: {
            fechaHora1: parts[0].trim(),
            fechaHora2: parts[1].trim(),
            usuario: [filtros.venUser],
          },
        },
        { responseType: "blob" }
      );
      const pdfBlob = new Blob([res.data], { type: "application/pdf" });
      saveAs(pdfBlob, `Cierre ${filtros.venUser}.pdf`);
    } catch (error) {
      mostrarAlerta("Error al generar cierre de ventas", "error");
    }
    setCargandoCierre(false);
  };

  const changeObjetoActivoStateInventario = (item) =>
    setObjectoActivoInventario(item);
  const changeObjetoActivoStateProveedor = (item) =>
    setObjectoActivoProveedor(item);

  const tieneFiltros = Object.entries(filtros).some(([key, val]) => {
    if (val === null || val === undefined) return false;
    return val !== filtrosDefault[key];
  });

  const ocultarAgregar =
    estadoRequest === "ANULADAS" ||
    estadoRequest === "DESPACHO" ||
    estadoRequest === "ALIMENTACION" ||
    estadoRequest === "COMBUSTIBLE";

  const reducer = (a, b) => Number(a) + Number(b);

  return {
    rows: table.rows,
    pagination: table.pagination,
    page: table.page,
    rowsPerPage: table.rowsPerPage,
    search: table.search,
    buscando: table.buscando,
    input: table.input,
    orden: table.orden,
    cargando: table.cargando,
    highlightId: table.highlightId,
    highlightType: table.highlightType,
    totalPages: table.totalPages,
    estadoRequest,
    open,
    editar,
    objectoActivo,
    filtros,
    tieneFiltros,
    ocultarAgregar,
    openProveedor,
    openProveedorModalI,
    editarProveedor,
    openInventario,
    editarInventario,
    openCategoria,
    openSubCategoria,
    openDialogOpciones,
    openExportDialog,
    mesExport,
    objectoActivoInventario,
    objectoActivoProveedor,
    arrayExport,
    socket,
    reducer,
    tienePermiso,
    alertaPermiso,
    desdeOtroLugarPersona,
    inputTxtSri,
    inputXmlSri,
    setSearch: table.setSearch,
    handleSearch: table.handleSearch,
    handleSort: table.handleSort,
    handleChangePage: table.handleChangePage,
    handleChangeRowsPerPage: table.handleChangeRowsPerPage,
    handleRefresh,
    handleClearSearch,
    setOpen,
    setEditar,
    changeObjetoActivoState,
    handleOpenNuevo,
    handleOpenEditar,
    editarState,
    handleChangeEstadoRequest,
    handleFiltrosChange,
    handleClearFiltros,
    funcArchivoTxtSri,
    funcArchivoXmlSri,
    handleAutorizarPorLote,
    funcPdfExport,
    funcExcelExport,
    funcExcelRecaudaciones,
    funcExcelVentaGas,
    funcCierreVentas,
    cargandoCierre,
    cargandoVentaGas,
    setOpenProveedor,
    setOpenProveedorModalI,
    setEditarProveedor,
    setOpenInventario,
    setEditarInventario,
    setOpenCategoria,
    setOpenSubCategoria,
    setOpenDialogOpciones,
    setOpenExportDialog,
    setMesExport,
    setArrayExport,
    changeObjetoActivoStateInventario,
    changeObjetoActivoStateProveedor,
  };
};

export default useFacturacion;
